import { AI_MODEL_LABELS, RagAiModel } from './RagAiModel';

export enum SummarisationAiModel {
  GPT_6_LUNA = 'GPT_6_LUNA',
  CLAUDE_5_5_HAIKU = 'CLAUDE_5_5_HAIKU'
}

// Label suffix shows where the model processes data.
export const SUMMARISATION_AI_MODEL_LABELS: Record<
  SummarisationAiModel,
  string
> = {
  [SummarisationAiModel.GPT_6_LUNA]: 'Open AI GPT-6 Luna (US)',
  [SummarisationAiModel.CLAUDE_5_5_HAIKU]:
    AI_MODEL_LABELS[RagAiModel.CLAUDE_5_5_HAIKU]
};
